import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import classNames from 'classnames';

import './card-remove-button.scss';

export function CardRemoveButton({
  onClick,
  trackingId = null,
  disabled = false,
  className = '',
  trackingValue = null,
  innerRef = null,
  ariaLabel = 'Saved Car',
  ariaDescribedBy = null,
}) {
  return (
    <Button
      color=""
      disabled={disabled}
      className={classNames('card-remove-button text-white icon-cross2 pos-a top-0 right-0', className)}
      onClick={onClick}
      data-tracking-id={trackingId}
      data-tracking-value={trackingValue}
      data-tracking-disabled={!trackingId}
      aria-label={`Remove ${ariaLabel}`}
      aria-describedby={ariaDescribedBy}
      innerRef={innerRef}
    />
  );
}

CardRemoveButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  trackingId: PropTypes.string,
  trackingValue: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  innerRef: PropTypes.shape(),
  ariaLabel: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
};
